module.exports = __webpack_public_path__ + "static/media/team-rick.a937ccd6.jpg";